import React from 'react';

import styled from 'styled-components';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { IPriceAndCalories } from './types';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 0.25rem;
  font-size: 0.9375rem;
  font-family: ${Styles.fontFamily.body};
  color: ${Styles.color.black};
  font-weight: ${Styles.fontWeight.normal};
  line-height: 1.1;
`;

const Price = styled.span`
  margin: 0;
  color: ${Styles.color.validated};
`;

const GreyStyledText = styled.span`
  margin: 0;
  color: ${Styles.color.grey.six};
`;

const Divider = styled.span`
  margin: 0 0.5rem;
  color: ${Styles.color.grey.two};
  font-family: ${Styles.fontFamily.body};

  ${Styles.mobileTiny`
    margin: 0 0.25rem;
  `}
`;

/**
 * Conditionally hide site-wide calories based on an LD flag. All rendered calories outside of
 * the nutrition explorer should be wrapped with this component
 */
export const Calories: React.FC<{ children: React.ReactNode }> = props => {
  const hideUiCalories = useFlag(LaunchDarklyFlag.HIDE_UI_CALORIES);

  if (hideUiCalories) {
    return null;
  }
  return <>{props.children}</>;
};

const PriceAndCalories: React.FC<IPriceAndCalories> = ({
  caloriesTestId = 'wizard-calories',
  className,
  currentPrice,
  formattedCalories,
  priceTestId = 'wizard-price',
  shouldHideCalories,
  shouldHidePrice,
}) => {
  const showCurrentPrice = !!currentPrice;
  const showCalories = !shouldHideCalories;
  const showPrice = !shouldHidePrice && showCurrentPrice;
  const showDivider = showPrice && showCalories;

  return (
    <Container className={className}>
      {showPrice && <Price data-testid={priceTestId}>{currentPrice}</Price>}
      {showCalories && (
        <Calories>
          {showDivider && <Divider>|</Divider>}
          <GreyStyledText data-testid={caloriesTestId}>{formattedCalories}</GreyStyledText>
        </Calories>
      )}
    </Container>
  );
};

export default PriceAndCalories;
